import navigation from "@src/navigation/vertical";

type NavMenuItem = {
  navLink?: string;
  permission?: string;
  children?: NavMenuItem[];
};

type NavPathEntry = {
  path: string;
  permission?: string;
};

const normalizePath = (path: string): string => {
  if (!path || path === "/") return "/";
  return path.replace(/\/+$/, "") || "/";
};

const collectNavPathEntries = (items: NavMenuItem[]): NavPathEntry[] => {
  const entries: NavPathEntry[] = [];

  for (const item of items) {
    if (item.navLink) {
      entries.push({
        path: normalizePath(item.navLink),
        permission: item.permission,
      });
    }

    if (item.children?.length) {
      entries.push(...collectNavPathEntries(item.children));
    }
  }

  return entries;
};

const NAV_PATH_ENTRIES = collectNavPathEntries(navigation as NavMenuItem[]);

/** Longest navLink prefix match — detail routes inherit list permission. */
export const getRequiredPermissionForPath = (pathname: string): string | undefined => {
  const normalized = normalizePath(pathname);
  let best: NavPathEntry | undefined;

  for (const entry of NAV_PATH_ENTRIES) {
    const link = entry.path;
    if (normalized === link || normalized.startsWith(`${link}/`)) {
      if (!best || link.length > best.path.length) {
        best = entry;
      }
    }
  }

  return best?.permission;
};

export const isPathAccessibleForUser = (
  pathname: string,
  checkPermission: (permissionName?: string) => boolean
): boolean => {
  const required = getRequiredPermissionForPath(pathname);
  if (!required) return true;
  return checkPermission(required);
};
